// extracted by mini-css-extract-plugin
export default {"cardcontent":"SingleValueCard_cardcontent__FujgL"};